import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  token: sessionStorage.getItem("token")
    ? sessionStorage.getItem("token")
    : null,
};
export const userSlice = createSlice({
  initialState,
  name: "token",
  reducers: {
    setToken: (state, action) => {
      console.log(action.payload);

      sessionStorage.setItem("token", action.payload);
      state.token = action.payload;
    },
  },
});
export default userSlice.reducer;
export const { setToken } = userSlice.actions;

export const currentToken = (state) => state?.User?.token;
